import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/feature/JsonLd";
import HeroSection from "./components/HeroSection";
import CategoryDropdown from "./components/CategoryDropdown";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedSection from "./components/FeaturedSection";
import ValueProposition from "./components/ValueProposition";
import SocialProof from "./components/SocialProof";
import BlogSection from "./components/BlogSection";
import CTASection from "./components/CTASection";

const SITE_URL = "https://pandabuy.quest";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "PandabuySpreadsheet Hub",
  "url": SITE_URL,
  "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg",
  "description": "The most advanced curated discovery platform for finding the best products through verified Pandabuy Spreadsheet lists. 50,000+ curated products, 1,200+ updated spreadsheets, daily trending updates.",
  "sameAs": [
    SITE_URL
  ]
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "PandabuySpreadsheet Hub",
  "url": SITE_URL,
  "description": "The most advanced curated discovery platform for finding the best products through verified Pandabuy Spreadsheet lists.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${SITE_URL}/?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

const homeWebPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Ultimate Pandabuy Spreadsheet Hub 2026 — Best Curated Finds for Sneakers, Streetwear & More",
  "url": SITE_URL,
  "description": "Discover the most updated Pandabuy Spreadsheet for 2026. Curated fashion, sneakers, streetwear, accessories, and tech finds — all in one place.",
  "isPartOf": {
    "@type": "WebSite",
    "name": "PandabuySpreadsheet Hub",
    "url": SITE_URL
  },
  "about": {
    "@type": "Thing",
    "name": "Pandabuy Spreadsheet",
    "description": "Curated product discovery spreadsheet for fashion, sneakers, streetwear, accessories, and tech"
  },
  "datePublished": "2026-06-29",
  "dateModified": "2026-06-29"
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <JsonLd data={homeWebPageSchema} />
      <Header />
      <main>
        <HeroSection />
        <CategoryDropdown />
        <FeaturedSection />
        <CategoryGrid />
        <ValueProposition />
        <SocialProof />
        <BlogSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}